import React, { useEffect, useState } from "react";
import CommonImageSlider from "./comandata";
import CallandRegisterComponent from "./CallandRegisterComponent";

export default function About() {
  const [about, setAbout] = useState(null);
  const [slides, setSlides] = useState([]);
  const [cta, setCta] = useState(null);
https://lifebix.com/rankridgedev/api/about
  useEffect(() => {
    Promise.all([
      fetch('https://lifebix.com/rankridgedev/api/about').then(r=>r.json()),
      fetch('https://lifebix.com/rankridgedev/api/sliders?group=about').then(r=>r.json()),
      fetch('https://lifebix.com/rankridgedev/api/cta').then(r=>r.json())
    ]).then(([aboutRes, slideRes, ctaRes]) => {
      setAbout(aboutRes);
      setSlides(slideRes);
      setCta(ctaRes);
    }).catch(console.error);
  }, []);

  if (!about || !cta) return null;

  return (
    <div>
      <h6 className="text-xl text-center text-black font-extrabold">
        {about.hero_title}
      </h6>

      <section className="flex flex-wrap m-1">
        <div className="w-full md:w-1/2 m-4">
          <CommonImageSlider images={slides.map(s => s.image_url)} />
        </div>

        <div className="w-full md:w-1/2 mt-8 m-4 ">
          <CallandRegisterComponent
            heading={cta.heading}
            buttonText={cta.button_text}
            buttonLink={cta.button_link}
            phoneDisplay={cta.phone_display}
            whatsappLink={cta.whatsapp_link}
            extraHtml={cta.extra_html}
          />
        </div>
      </section>

      <section className="bg-white px-1 md:px-12 py-1 text-green-900 mt-3">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold mt-2 mb-4 text-center ms-4 me-4">
              {about.sub_title}
            </h1>
            <div
              className="text-gray-700 text-base md:text-lg text-start ms-8 me-8"
              dangerouslySetInnerHTML={{ __html: about.intro_html }}
            />
          </div>
          <div className="flex justify-center mb-8">
            <img src={about.main_image} alt="Students collaborating"
                 className="w-full max-w-md rounded-xl shadow-lg"/>
          </div>
        </div>
      </section>
    </div>
  );
}
